// This component is used for showing translate animations, by having a block that moves between left and right.
import { styled } from '@linaria/react';

export const BLOCK_WIDTH = 48;
export const CONTAINER_WIDTH = 300;
export const PADDING = 12;
export const DISPLACEMENT =
  CONTAINER_WIDTH - BLOCK_WIDTH - PADDING * 2;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  blockAs?: React.ElementType;
  // This needs to be `any` since it might be a React Spring type object, based on `blockAs`.
  style: any;
  ref?: React.RefObject<HTMLDivElement>;
}

function AnimatedBlock({
  style,
  blockAs: BlockComponent = 'div',
  ...delegated
}: Props) {
  return (
    <BlockWrapper {...delegated}>
      <BackgroundLayer>
        <GhostBlock />
        <Track />
        <GhostBlock />
      </BackgroundLayer>
      <Block as={BlockComponent} style={style} />
    </BlockWrapper>
  );
}

const BlockWrapper = styled.div`
  width: ${CONTAINER_WIDTH}px;
  position: relative;
  padding: ${PADDING}px;
  outline: 1px solid var(--color-gray-400);
  border-radius: 4px;
  overflow: hidden;
`;

const BackgroundLayer = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  gap: 8px;
  padding: ${PADDING}px;
`;

const Block = styled.div`
  width: ${BLOCK_WIDTH}px;
  height: ${BLOCK_WIDTH}px;
  background: hsl(155.69deg 100% 65.72%);
  background: oklch(0.87 0.28 152.73);
  border-radius: 50%;
  outline: 3px solid var(--color-background);
`;

const Track = styled.div`
  flex: 1;
  align-self: center;
  height: 0px;
  border-bottom: 1px dashed var(--color-gray-400);
`;

const GhostBlock = styled(Block)`
  background: transparent;
  outline: 1px dashed var(--color-gray-400);
  outline-offset: 3px;
`;

export default AnimatedBlock;
